<div class="container">

  <div class="portalCard">
    <div class="aTitle">
      <mat-icon>chat</mat-icon>
      <span>Antragsverwaltung</span>
    </div>
    <ng-container *ngIf="isIsselhorsterReady(); else fallback">
      @if (isIsselhorsterReady()) {
        <antrgsuebersicht-app embedded></antrgsuebersicht-app>
      }
    </ng-container>
    <ng-template #fallback>
      <div style="opacity:.7">Die Antragsverwaltung ist für diesen Mandanten nicht aktiviert.</div>
    </ng-template>
  </div>
</div>

